import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

// `state.url` trae la ruta completa a la que la persona intentaba entrar
// (ej. "/cups/design-your-cup") - se manda como query param "redirect" al
// login para que, después de iniciar sesión, login.component.ts pueda
// devolver a la persona ahí en vez de mandarla siempre a home/dashboard.
export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    return true;
  }

  // Si no está autenticado, redirigir al login recordando a dónde iba
  return router.createUrlTree(['/login'], { queryParams: { redirect: state.url } });
};
